import ReactDOM from "react-dom";
import { useEffect } from "react";

function Modal({onClose, children, actionBar, header, modalSize}){
    useEffect(()=>{
        document.body.classList.add('overflow-hidden');
        return () => {
            document.body.classList.remove('overflow-hidden')
        }
    },[]);

//<div className={`fixed inset-x-${modalSize} inset-y-${modalSize} p-2 bg-white rounded-md`}>
// inset-x-1/4 inset-y-1/4
    return ReactDOM.createPortal(
        <div>
            <div onClick={onClose} className="fixed inset-0 bg-gray-300 opacity-80"></div>
            <div className={`fixed inset-x-1/4 inset-y-1/4  p-2 bg-white rounded-md`}>
                <div className="h-full bg-slate-100 my-auto grid-cols-3 rounded-md"> {/*relative flex flex-col justify-between  */}
                    <div className="grid grid-cols-2 mb-4">
                        <div className="justify-start ">{header()}</div>
                        <div className="flex justify-end ">{actionBar}</div>
                    </div>

                    {children}

                </div>
            </div>
        </div>,
        document.querySelector('.modal-container')/**Está definido en el index.html */
    );
}
export default Modal;